(function () {
  'use strict';

  function updateShippingBar(cartTotalCents) {
    const bars = document.querySelectorAll('.vosse-shipping-bar');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      const thresholdCents = parseInt(bar.dataset.threshold, 10) || 10000000;
      const pct = Math.min((cartTotalCents / thresholdCents) * 100, 100);
      const remainingCents = Math.max(thresholdCents - cartTotalCents, 0);
      const unlocked = cartTotalCents >= thresholdCents;

      const fill = bar.querySelector('.vosse-shipping-bar__fill');
      if (fill) {
        fill.style.width = Math.round(pct) + '%';
        fill.classList.toggle('vosse-shipping-bar__fill--unlocked', unlocked);
        bar.querySelector('.vosse-shipping-bar__track')
           .setAttribute('aria-valuenow', Math.round(pct));
      }

      const curEl = bar.querySelector('.vosse-shipping-bar__current');
      if (curEl) curEl.textContent = new Intl.NumberFormat('es-AR', {
        style: 'currency', currency: 'ARS', minimumFractionDigits: 0
      }).format(cartTotalCents / 100);

      const msgEl = bar.querySelector('.vosse-shipping-bar__message');
      if (msgEl) {
        if (unlocked) {
          msgEl.innerHTML = '<span class="vosse-shipping-bar__message--unlocked">¡Felicidades! Tu envío a toda la provincia es <strong>GRATIS</strong></span>';
        } else {
          msgEl.innerHTML = '<span class="vosse-shipping-bar__message--pending">Te faltan <strong>' +
            new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 0 }).format(remainingCents / 100) +
            '</strong> para desbloquear el ENVÍO GRATIS</span>';
        }
      }
      bar.dataset.cartTotal = cartTotalCents;
    });
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.cart !== 'undefined') {
      updateShippingBar(e.detail.cart.total_price);
    }
  });

})();
/* =============================================================
   Vosse — Size Guide Modal
   ============================================================= */
var vosseSizeGuide = {
  open: function () {
    var el = document.getElementById('vosseSizeGuideOverlay');
    if (el) { el.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
  },
  close: function () {
    var el = document.getElementById('vosseSizeGuideOverlay');
    if (el) { el.style.display = 'none'; document.body.style.overflow = ''; }
  },
  closeOnBg: function (e) {
    if (e.target === document.getElementById('vosseSizeGuideOverlay')) this.close();
  },
  switchTab: function (name, btn) {
    document.querySelectorAll('.vosse-sg__panel').forEach(function(p){ p.classList.remove('active'); });
    document.querySelectorAll('.vosse-sg__tab').forEach(function(t){ t.classList.remove('active'); });
    var panel = document.getElementById('vosse-sg-' + name);
    if (panel) panel.classList.add('active');
    if (btn) btn.classList.add('active');
  }
};
document.addEventListener('keydown', function(e){
  if (e.key === 'Escape') vosseSizeGuide.close();
});
/* =============================================================
   Vosse — Sticky ATC Mobile
   ============================================================= */
var vosseStickyATC = {
  init: function () {
    var bar = document.getElementById('vosseStickyAtc');
    var mainBtn = document.querySelector('[name="add"]');
    if (!bar || !mainBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          bar.classList.add('visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0.5 });

    observer.observe(mainBtn);
  },

  addToCart: function () {
    var mainBtn = document.querySelector('[name="add"]');
    if (mainBtn && !mainBtn.disabled) {
      mainBtn.click();
    }
  }
};

document.addEventListener('DOMContentLoaded', function () {
  vosseStickyATC.init();
});